import type { Locale } from '@change-corgi/config/locales';

import __data from '../config/guides.json';

import type { Guide } from './types';

type GuideUrls = Partial<Record<Guide, string>>;

export const guideUrls = __data as unknown as Record<Locale, GuideUrls>;
